var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-green table-to-file",class:_vm.small ? 'btn-sm' : '',attrs:{"type":"button","disabled":_vm.propDisable},on:{"click":function($event){return _vm.downloadExcel()}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('em',{staticClass:"fa fa-download"})])
}
var staticRenderFns = []

export { render, staticRenderFns }